import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "gg_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const set = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-4 bottom-4 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-[60] bg-ink2 text-white rounded-lg border border-white/10 shadow-2xl"
    >
      <div className="p-6">
        <h4 className="font-display text-base font-semibold mb-2">Používáme cookies</h4>
        <p className="text-sm text-white/70 leading-relaxed">
          Používáme nezbytné cookies pro správný chod webu. Volitelně analytiku pro zlepšování obsahu.
          Více informací v{" "}
          <Link to="/cookies" className="text-magenta hover:underline" data-testid="cookie-link-cookies">
            zásadách cookies
          </Link>
          .
        </p>
        <div className="mt-5 flex flex-col sm:flex-row gap-3">
          <button
            data-testid="cookie-accept"
            onClick={() => set("all")}
            className="bg-magenta hover:bg-magenta-dark text-white text-sm font-medium px-5 py-2.5 rounded-full transition-colors"
          >
            Přijmout vše
          </button>
          <button
            data-testid="cookie-essential"
            onClick={() => set("essential")}
            className="border border-white/30 hover:border-magenta hover:text-magenta text-white text-sm font-medium px-5 py-2.5 rounded-full transition-colors"
          >
            Pouze nezbytné
          </button>
        </div>
      </div>
    </div>
  );
}
